import { render, staticRenderFns } from "./ContainerDetailsModal.vue?vue&type=template&id=678cec80"
import script from "./ContainerDetailsModal.vue?vue&type=script&lang=js"
export * from "./ContainerDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./ContainerDetailsModal.vue?vue&type=style&index=0&id=678cec80&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports